import React, { useState } from 'react';
import styles from './InPageChat.module.scss'; // We'll use the same styles

export interface Citation {
  sourceId: string;
  sourceName: string;
  location: string | null;
  confidence?: number;
  confidenceTier?: 'high' | 'medium' | 'low';
}

interface CitationsProps {
  citations: Citation[];
}

const Citations: React.FC<CitationsProps> = ({ citations }) => {
  const [isCollapsed, setIsCollapsed] = useState(true);

  const formatConfidence = (citation: Citation): string | null => {
    if (typeof citation.confidence === 'number' && Number.isFinite(citation.confidence)) {
      return `Confidence: ${(citation.confidence * 100).toFixed(0)}%`;
    }
    if (citation.confidenceTier) {
      return `Confidence: ${citation.confidenceTier.charAt(0).toUpperCase()}${citation.confidenceTier.slice(1)}`;
    }
    return null;
  };

  if (!citations || citations.length === 0) return null;

  return (
    <div className={styles.citationsContainer}>
      <div className={styles.citationsHeader} onClick={() => setIsCollapsed(!isCollapsed)}>
        <span className={styles.citationsTitle}>Sources ({citations.length})</span>
        <span className={styles.collapseIndicator}>
          {isCollapsed ? '▶' : '▼'}
        </span>
      </div>
      {!isCollapsed && (
        <div className={styles.citationsList}>
          {citations.map((citation, index) => {
            const confidenceText = formatConfidence(citation);
            return (
              <div key={index} className={styles.citationItem}>
                <div className={styles.citationName}>{citation.sourceName}</div>
                <div className={styles.citationId}>{citation.sourceId}</div>
                {confidenceText && <div className={styles.citationConfidence}>{confidenceText}</div>}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Citations;